import o from"@userfront/react";const r={};for(const t in o)r[t]||(r[t]=o[t]);export default r;
//# sourceMappingURL=userfront-nextjs.module.js.map
